exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".source-icon--image{height:1.5rem;width:1.5rem}.source-icon--nav-item{height:18px;width:18px}", ""]);

